export default {"src":"/_next/static/media/residential5.42d774ee.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};